export const end_customer_url: string = "end_customer";
export const fabrication_job_url: string = "fabrication_job";